export { getSearchStore } from './store/Store';
